import { createContext } from 'react'

import type { CableEventListener } from '@/types/cable'

export interface AnswerStreamContext {
  subscribe: (listener: CableEventListener) => () => void
  markPending: (conversationId: string, userMessageId: string) => void
  clearPending: (conversationId: string) => void
  getPending: (conversationId: string) => string | undefined
}

const AnswerStreamCtx = createContext<AnswerStreamContext>({
  subscribe: () => () => {},
  markPending: () => {},
  clearPending: () => {},
  getPending: () => undefined,
})

export default AnswerStreamCtx
